import { useMedia } from "use-media";

const mediaQueryCond = "(max-width: 800px)";
const mediaQueryCond900 = "(max-width: 900px)";
const mediaQueryCondTablet = "(max-width: 1200px)";
export const useIsMobile = () => useMedia(mediaQueryCond);
export const useIsMobile900 = () => useMedia(mediaQueryCond900);
export const useIsTablet = () => useMedia(mediaQueryCondTablet);
